<template>
  <!-- downloadMultiDips Modal -->
  <form @submit.prevent>
    <div
      class="modal fade"
      id="downloadMultiDipsModal"
      tabindex="-1"
      aria-labelledby="downloadMultiDipsModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="downloadMultiDipsModalLabel">
              Download Confirmation
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label v-show="secretCount != 0 && nonSecretCount != 0"
                >You have selected
                <span style="color: red">{{ secretCount }} Secret DIP</span> and
                {{ nonSecretCount }} non-secret DIP. Do you want to proceed to
                download?</label
              >
              <label v-show="secretCount == 0 && nonSecretCount != 0"
                >You have selected {{ nonSecretCount }} non-secret DIP. Do you
                want to proceed to download?</label
              >
              <label v-show="secretCount != 0 && nonSecretCount == 0"
                >You have selected
                <span style="color: red">{{ secretCount }} Secret DIP</span>. Do
                you want to proceed to download?</label
              >
            </div>
            <div class="mb-3">
              <li v-for="(item, index) in checkedData" :key="index">
                <span
                  v-if="item.securityGrading != 'Secret'"
                  type="button"
                  class="btn btn-secondary btn-selected position-relative"
                  style="margin-right: 4px; margin-top: 4px; margin-bottom: 4px"
                >
                  {{ item.packageId }} </span
                ><span
                  v-else-if="item.securityGrading == 'Secret'"
                  type="button"
                  class="btn btn-danger btn-secret position-relative"
                  style="margin-right: 4px; margin-top: 4px; margin-bottom: 4px"
                >
                  {{ item.packageId }}
                </span>
              </li>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              style="width: 48.5%"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-success"
              style="width: 48.5%"
              data-bs-dismiss="modal"
              @click="downloadMultiDips"
            >
              Download DIPs
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- downloadSingleDip Modal -->
  <form @submit.prevent>
    <div
      class="modal fade"
      id="downloadSingleDipModal"
      tabindex="-1"
      aria-labelledby="downloadSingleDipModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="downloadSingleDipModalLabel">
              Download Confirmation
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label v-show="securityGrading != 'Secret'"
                >You have selected 1 non-secret DIP. Do you want to proceed to
                download?</label
              >
              <label v-show="securityGrading == 'Secret'"
                >You have selected
                <span style="color: red">1 {{ securityGrading }} DIP</span>. Do
                you want to proceed to download?</label
              >
            </div>
            <div class="mb-3">
              <span
                v-show="securityGrading != 'Secret'"
                type="button"
                class="btn btn-secondary btn-selected position-relative"
                style="margin-right: 4px; margin-top: 4px; margin-bottom: 4px"
              >
                {{ packageId }}
              </span>
              <span
                v-show="securityGrading == 'Secret'"
                type="button"
                class="btn btn-danger btn-secret position-relative"
                style="margin-right: 4px; margin-top: 4px; margin-bottom: 4px"
              >
                {{ packageId }}
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              style="width: 48.5%"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-success"
              style="width: 48.5%"
              data-bs-dismiss="modal"
              @click="downloadSingleDip"
            >
              Download DIPs
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>

  <!-- deleteMultiDips Modal -->
  <!-- <form @submit.prevent>
    <div
      class="modal fade"
      id="deleteMultiDipsModal"
      tabindex="-1"
      aria-labelledby="deleteMultiDipsModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteMultiDipsModalLabel">
              Delete Confirmation
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label
                >You have selected the following DIPs. Do you want to proceed to
                delete?</label
              >
            </div>
            <div class="mb-3">
              <li v-for="(item, index) in checkedData" :key="index">
                <span
                  type="button"
                  class="btn btn-secondary btn-selected position-relative"
                  style="margin-right: 4px; margin-top: 4px; margin-bottom: 4px"
                >
                  {{ item }}
                </span>
              </li>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              style="width: 48.5%"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-danger"
              style="width: 48.5%"
              data-bs-dismiss="modal"
              @click="deleteDips"
            >
              Delete DIPs
            </button>
          </div>
        </div>
      </div>
    </div>
  </form> -->

  <!-- deleteSingleDip Modal -->
  <!-- <form @submit.prevent>
    <div
      class="modal fade"
      id="deleteSingleDipModal"
      tabindex="-1"
      aria-labelledby="deleteSingleDipModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="deleteSingleDipModalLabel">
              Delete Confirmation
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="mb-3">
              <label
                >You have selected the following DIP. Do you want to proceed to
                delete?</label
              >
            </div>
            <div class="mb-3">
              <span
                type="button"
                class="btn btn-secondary btn-selected position-relative"
                style="margin-right: 4px; margin-top: 4px; margin-bottom: 4px"
              >
                {{ packageId }}
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              style="width: 48.5%"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="submit"
              class="btn btn-danger"
              style="width: 48.5%"
              data-bs-dismiss="modal"
              @click="deleteDips"
            >
              Delete DIPs
            </button>
          </div>
        </div>
      </div>
    </div>
  </form> -->
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
};
</script>

<script setup lang="ts">
import { useDIPStore } from "@/stores/dip";
import { ref, watch } from "vue";

const checkedData: any = ref();
const packageId: any = ref();
const transferId: any = ref();
const securityGrading: any = ref();
const secretCount = ref(0);
const nonSecretCount = ref(0);
const dipStore = useDIPStore();
const emit = defineEmits(["listen-refresh-table"]);
const isLoading = ref(false);

const props = defineProps({
  checkedData: { type: Array },
  selectedPackageId: { type: String },
  selectedTransferId: { type: String },
  selectedSecurityGrading: { type: String },
});

watch(
  () => props.checkedData,
  (newId) => {
    checkedData.value = newId;
    secretCount.value = 0;
    nonSecretCount.value = 0;
    for (let i = 0; i < checkedData.value.length; i++) {
      if (checkedData.value[i].securityGrading == "Secret") {
        secretCount.value++;
      } else {
        nonSecretCount.value++;
      }
    }
  }
);

watch(
  () => props.selectedPackageId,
  (selectedPackageId) => (packageId.value = selectedPackageId)
);

watch(
  () => props.selectedTransferId,
  (selectedTransferId) => (transferId.value = selectedTransferId)
);

watch(
  () => props.selectedSecurityGrading,
  (selectedSecurityGrading) => (securityGrading.value = selectedSecurityGrading)
);

watch(
  () => dipStore.multidownloaddipnumber,
  () => {if(dipStore.multidownloaddipnumber!=0){
               downloadMultiDips()
              }
        },
);


const downloadMultiDips = () => {
   if (checkedData.value.length>dipStore.multidownloaddipnumber){  
      setTimeout(function() {
        dipStore.downloadMultiDip(
          checkedData.value[dipStore.multidownloaddipnumber].transferId,
          checkedData.value[dipStore.multidownloaddipnumber].packageId,
          checkedData.value[dipStore.multidownloaddipnumber].securityGrading
        )
      }, 100)

   }else{
      // console.log("update dipStore.multidownloaddipnumber to 0");
      alert("The DIP (" + dipStore.errorIdArray + ") is more than 7 days old and has been removed.");
      dipStore.updateDownloadDipNumber();
   }

  // too many reuqest browser or server will auto cancel some request
  // for (let i = 0; i < checkedData.value.length; i++) {
  //   dipStore.downloadDip(
  //     checkedData.value[i].transferId,
  //     checkedData.value[i].packageId,
  //     checkedData.value[i].securityGrading
  //   );  
  // }

};


const downloadSingleDip = () => {
  dipStore.downloadDip(
    transferId.value,
    packageId.value,
    securityGrading.value
  );
};
// const deleteDips = () => {
//   console.log("delete: ", packageId.value, checkedData.value);
// };
</script>

<style scoped>
li {
  padding-right: 10px;
  margin: auto;
  display: inline-block;
}
.btn-selected:hover {
  cursor: default;
  background: #6c757d;
}

.btn-secret:hover {
  cursor: default;
  background: #dc3545;
}
</style>
